import { Grid, Typography } from "@mui/material";

const styles = {
  badge: {
    my: 2,
    background: "#151F16",
    p: 5,
    borderRadius: "20px",
  },
  descriptionLargeText: {
    textAlign: "center",
    fontSize: "28px",
    color: "white",
    fontWeight: 600,
    mb: 2,
  },
  descriptionText: {
    fontSize: "16px",
    textAlign: "center",
    color: "white",
  },
  ctaBox: {
    p: 3,
    mt: 3,
    background: "white",
    borderRadius: "20px",
  },
  button: {
    px: 3,
    py: 2,
    textTransform: "none",
    borderRadius: 20,
    my: 2,
  },
};

export default function FullReportInProgress() {
  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionLargeText}>
          📑
          <br />
          Your{" "}
          <Typography
            component="span"
            sx={[styles.descriptionLargeText, { color: "#F7EE6F" }]}
          >
            Full Report
          </Typography>{" "}
          is coming soon!
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          Once we have processed the deals in your email, we'll send you an
          email with the complete report of brand-by-brand insights and growth
          suggestions
        </Typography>
      </Grid>
    </Grid>
  );
}
